if (!customElements.get("product-carousel")) {
  class a extends HTMLElement {
    constructor() {
      super();
      var e = this.querySelector(".swiper-scrollbar"),
        r = this.querySelector(".arrow--left"),
        s = this.querySelector(".arrow--right");
      const hasCover = this.querySelector('.swiper').classList.contains('swiper--has-cover');
      
      new Swiper(this.querySelector(".swiper-container"), {
        loop: !1,
        grabCursor: !1,
        speed: 500,
        spaceBetween: 8,
        slidesPerView: 2,
        watchSlidesProgress: !0,
        scrollbar: { el: e, enabled: !0 },
        navigation: { nextEl: s, prevEl: r },
        breakpoints: {
          768: { spaceBetween: 16, slidesPerView: 3 },
          1200: { spaceBetween: 16, slidesPerView: hasCover ? 3 : 4 },
        },
      });
    }
  }
  customElements.define("product-carousel", a);
}
